import { render, staticRenderFns } from "./CostPage.vue?vue&type=template&id=6b7e90ea&scoped=true&lang=html"
import script from "./CostPage.vue?vue&type=script&lang=js"
export * from "./CostPage.vue?vue&type=script&lang=js"
import style0 from "./CostPage.vue?vue&type=style&index=0&id=6b7e90ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7e90ea",
  null
  
)

export default component.exports